import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { ShareProductModalComponent } from '../../../shared/components/share-product-modal/share-product-modal.component';
import { AnalyticsService } from '../../../shared/services/analytics.service';
import { UtilsService } from '../../../shared/services/utils.service';
import { DataLayerService } from '../../../shared/services/gtm-service/data-layer.service';
import { environment } from '../../../environments/environment';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TruncatePipe } from '../../../shared/pipes/truncate.pipe';

@Component({
  selector: 'app-product-card',
  standalone: true,
  imports: [CommonModule,MatCheckboxModule,TruncatePipe,RouterModule],
  templateUrl: './product-card.component.html',
  styleUrl: './product-card.component.scss'
})
export class ProductCardComponent implements OnInit, OnDestroy {
  @Input() productData: any;
  @Input() recommendedSol!: boolean;
  @Input() isCompare!: boolean;
  @Input() limitChecked!: boolean;
  @Output() submitProducts = new EventEmitter();
  @Input() offerText: any;
  @Input() sourcePage: string = '';
  environment: any = environment;
  isChecked: boolean = false;
  isEshop!: boolean;
  slideData: any = []
  sub:Subscription=new Subscription()
  customOptions: OwlOptions = {
    loop: false,
    autoplay: false,
    center: false,
    dots: false,
    autoHeight: true,
    stagePadding: 0,
    pullDrag: true,
    margin: 0,
    responsive: {
      0: {
        items: 1,
      }
    }
  }
  constructor(private router: Router, private dataLayerService: DataLayerService, private route: ActivatedRoute, private analyticsService: AnalyticsService, public dialog: MatDialog, public utils: UtilsService) {
  }
  ngOnInit(): void {
    this.setSlideData();
    if (!this.recommendedSol) {
      this.recommendedSol = false
    }
  }

  getPDPRoute(guid: any, productName: any) {
    let name = this.utils.createNameForUrl(productName ? productName : '')
    return `/product/${name}`;
  }

  triggerSelectEvent() {
    if (this.offerText) {
      if (this.sourcePage === 'avl') {
        this.dataLayerService.triggerSelectItem(this.productData, 'avl');
      } else if (this.sourcePage === 'non-avl') {
        this.dataLayerService.triggerSelectItem(this.productData, 'non-avl');
      }
    }
    this.dataLayerService.triggerSelectItem(this.productData, 'select_item');
  }

  setSlideData() {
    let imgArr: any = [];
    let obj: any = {}
    obj['image'] = this.productData.productImage;
    obj['altTag'] = this.productData.productImageAlt;
    imgArr.push(obj);
    this.slideData = JSON.parse(JSON.stringify(imgArr));
    if (this.slideData && this.slideData.length > 1) {
      this.customOptions.dots = true;
    }
  }

  openShareDialog(guid: any, productName: any): void {
    const dialogRef = this.dialog.open(ShareProductModalComponent, {
      disableClose: true,
      maxWidth: '417px',
      width: '100%',
      panelClass: 'productShareModel',
      data: {
        productGuidId: guid,
        productName: productName
      }
    });
    this.sub.add( dialogRef.afterClosed().subscribe((res: any) => {
    }));
  }

  onCheckboxClick(filterOption: any, flag: boolean) {
    this.submitProducts.emit({ value: filterOption, flag })
    this.isChecked = flag
  }

  ngOnDestroy(): void {
    this.utils.isCheckedLimit = false;
    this.sub.unsubscribe()
  }
}
